module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("The author is a retired investment banker who was born in France of a White Russian "), _c('em', [_vm._v("émigré")]), _vm._v(" father and a French mother. He grew up and was educated in the United States – at Deerfield Academy and Harvard College. He pursued a distinguished career in the City of London, and then lived in France for many years. He now lives in South Africa. He has published two books: "), _c('em', [_vm._v("Two Lives, a Social & Financial Memoir")]), _vm._v(" in 2017, and "), _c('em', [_vm._v("Lives of the Luberon")]), _vm._v(" in 2019. He is married and has three children.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f37d542","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0